import React from 'react';

import logoText from '../../assets/images/logo-with-text.svg';

export const LogoWithText: React.FC = () => (
  <>
    <img src={logoText} alt="Logo" />
  </>
);
